export default "__VITE_ASSET__fmwqevT3__"